import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { HouseCargoV2, UpdateHouseCargoV2Request } from '../domain/houseCargo'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export const getHouseShipmentsV2HouseCargo = async (houseShipmentID: string): Promise<HouseCargoV2> => {
  return await client.get<HouseCargoV2>(`/house-shipments/v2/${houseShipmentID}/house-cargo
`)
}

export type UpdateHouseShipmentsHouseCargoProps = {
  houseShipmentID: string
  houseCargoID: string
  data: UpdateHouseCargoV2Request
}
export const updateHouseShipmentsV2HouseCargo = async (props: UpdateHouseShipmentsHouseCargoProps): Promise<void> => {
  await client.put(`/house-shipments/v2/${props.houseShipmentID}/house-cargo/${props.houseCargoID}`, props.data)
}

export type RequestHouseShipmentCancellationProps = {
  houseShipmentID: string
  reason: string | null
}
export const requestHouseShipmentCancellation = async (props: RequestHouseShipmentCancellationProps): Promise<void> => {
  await client.post(`/api/shipments/customer/house-shipments/v2/${props.houseShipmentID}/requestCancellation`, {
    reason: props.reason,
  })
}
